import React from 'react';
import HomeLayout from './components/home_layout';
import ContainerComponent from '../../helpers/components/container.component';
import './home.css';

const HomeIndex = () => {
    return (
        <>
            <ContainerComponent span={22} top={20} bottom={20}>
                <HomeLayout />
            </ContainerComponent>
        </>
    );
}

export default HomeIndex;